<template>
	<div id="app" :class="[displayMode,isMobile]">
		<div class="loader" v-if="showLoader">
			<div class="loader-image">
				<img src="./assets/loading.svg" style="height: 100%;width: 100%;" />
			</div>
		</div>
		<div class="loader-overlay-text" v-if="showLoaderText">
			<div class="loader-image-text">
				<h1>{{ showLoaderTextTitle }}</h1>
				<img src="./assets/loading.svg" style="height: 100%;width: 100%;" />
			</div>
		</div>
		<div class="notification" v-if="$store.state.notification.show">
			{{ $store.state.notification.text }}
		</div>
		<Nav v-if="showdefaultnav" />

		<div
			v-if="
				$store.state.base_url &&
					$store.state.globalconfigs &&
					$store.state.showpackage
			"
		>
			<router-view></router-view>
		</div>
		<Popup v-if="showPopup" />
		<SpecialPlanPopup v-if="showSpecialPlanPopUp"/>
		<!-- Footer -->
		<Footer v-if="showdefaultFooter" />
		<!-- Footer -->
	</div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import Popup from "@/pages/Popup.vue";
import SpecialPlanPopup from "@/pages/SpecialPlanPopUp.vue"
import TheHeader from "@/components/Navigation/TheHeader";
import TheSidenav from "@/components/Navigation/TheSidenav";
import Helpers from "./Mixins/Helpers.js";
export default {
	name: "app",
	components: {
		Navbar,
		Footer,
		TheHeader,
		TheSidenav,
		Nav,
		Popup,
		SpecialPlanPopup,
	},
	mixins: [Helpers],
	metaInfo: {
		title: "iBAKATV | Watch, Download Premium Nollywood Movies and TV Series",
		meta: [
			{
				name: "description",
				content:
					"IBAKATV is an online movie streaming service that offers large varieties of the latest premium Nollywood blockbuster movies and TV series with genres ranging from Drama, Thriller, Crime, Family, Romance, etc.",
			},
		],
	},
	data() {
		return {
			displaySidenav: false,
			isMobile:false
		};
	},

	computed: {
		showLoader() {
			return this.$store.state.loader;
		},
		showLoaderText() {
			return this.$store.state.loaderText.show;
		},
		showLoaderTextTitle() {
			return this.$store.state.loaderText.text;
		},
		showdefaultnav() {
			return this.$store.state.showdefaultnav;
		},
		showdefaultFooter() {
			return this.$store.state.showdefaultFooter;
		},
		showPopup() {
			return this.$store.state.showPopup;
		},
		showSpecialPlanPopUp(){
			return this.$store.state.showSpecialPopUp;
		},
		displayMode() {
			return this.$store.getters.getDisplayMode;
		},
	},
	beforeCreate() {
		this.$store.commit("setLoader", true);
		this.$store.dispatch("getToken").then((res) => {
			this.$store.dispatch("getConfig").then((res) => {
				this.$store.dispatch("getPackages").then((res) => {
					this.$store.commit("setLoader", false);
				});
			});

			this.$store.dispatch("isUserauthenticated");
		});
	},
	mounted() {
		console.log("v-2.0.5");
		HelpCrunch("init", "ibakatv", {
			applicationId: 1,
			applicationSecret:
				"8xURIp4dEHPLP71Cpxe8Qks+EDcuCnCLqJpGVCMnDg5S+YO096VYp3sUE+cRp1QWRtKdtsdJU81TIpyG2pTN9g==",
		});

		HelpCrunch("showChatWidget");

		
	},
	created() {
		this.$store.commit("showPopup", false);
		this.isMobile = this.isPlatformMobile()?'mobile':'';
		const displayMode = localStorage.getItem("displayMode")
		if(displayMode){
			if(displayMode =="dark"){
				this.$store.commit("setDisplayMode",displayMode)
			}
			else{
				this.$store.commit("setDisplayMode")
			}
		}
		
	},
	methods:{
	
	}
};
</script>

<style>
.loader {
	position: fixed;
	top: 0px;
	left: 0px;
	right: 0px;
	bottom: 0px;
	background-color: var(--pricing-heading-text-color);
	z-index: 5000;
}
.loader-overlay-text {
	position: fixed;
	top: 0px;
	left: 0px;
	right: 0px;
	bottom: 0px;
	background-color: #f1f2f2;
	color: #80b440;
	z-index: 5000;
}
.loader-image {
	position: absolute;
	height: 200px;
	width: 200px;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
}
.loader-image-text {
	position: absolute;
	height: 200px;
	width: 100%;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	margin: 0 auto;
	text-align: center;
}
.notification {
	position: fixed;
	right: 5%;
	text-align: right;
	padding: 10px;
	margin: 10px;
	top: 10px;
	border: 1px solid #ffff;
	background: #fff;
	border-radius: 5px;
	z-index: 500;
}

.classB {
	max-height: 100px;
	/* overflow: hidden !important; */
}
:root.dark {
	--background-color-primary: #1e1e1e;
	--background-color-secondary: #2d2d30;
	--accent-color: #3f3f3f;
	--text-primary-color: #ddd;
	--home-overlay-background-color: rgba(0, 0, 0, 0.3);
	--bg-primary-background-color: #1e1e1e;
	--btn-outline-dark-bg-color: #fff;
	--btn-outline-dark-color: #fff ;
	--btn-outline-dark-border-color: #707070;
	--btn-hover-color:#fff;
	--card-header-border-bottom: none;
	--btn-outline-light-bg-color:#FFFFFF1A; 
	--btn-outline-light-color:#F1F2F2;
	--btn-outline-light-active-bg-color:#181818;
	--btn-outline-light-border-color: #707070;
	--custom-card-a-text:#679F3D;
	--custom-card-bg-color:#181917;
	--navbar-bg-color:#212121;
	--dropdown-menu-bg-color:rgba(0, 0, 0, 0.3);
	--dropdown-menu-text-color:#F1F2F2;
	--dropdown-menu-active-bg-color:#FFFFFF1A;
	--checkout-list-group-border-color:#707070;
	--pricing-heading-text-color:#181917;
	--pricing-heading-color:#F1F2F2;
	--privacy-banner-bg-color:#181818;
	--bg-dark-mode-background-color:#181818;
}
:root {
	--background-color-primary: #e6e6e6;
	--background-color-secondary: #fafafa;
	--accent-color: #cacaca;
	--text-primary-color: #222;
	--element-size: 4rem;
	--home-overlay-background-color: rgba(103, 159, 61, 0.88);
	--bg-primary-background-color: #679f3d;
	--btn-outline-dark-active-bg-color: #181917;
	--btn-outline-dark-bg-color: #fafafa;
	--btn-outline-dark-active-color: #fff;
	--btn-outline-dark-color:  #181917;
	--btn-outline-dark-border-color: #181917;
	--btn-hover-color:#212529;
	--card-header-border-bottom:1px solid rgba(0,0,0,.125);
	--btn-outline-light-bg-color:#679F3D; 
	--btn-outline-light-color:#F1F2F2;
	--btn-outline-light-active-bg-color: #80b440;
	--btn-outline-light-border-color: #F1F2F2;
	--custom-card-a-text:#181917;
	--custom-card-bg-color:#fff;
	--navbar-bg-color:#679f3d;
	--dropdown-menu-bg-color:#fff;
	--dropdown-menu-text-color:#212529;
	--dropdown-menu-active-bg-color:#F1F2F2;
	--checkout-list-group-border-color:#fff;
	--pricing-heading-text-color:#F1F2F2;
	--pricing-heading-color:#181917;
	--privacy-banner-bg-color:#e6e6e6;
	--bg-dark-mode-background-color:#fff;

}

@import "~bootstrap/dist/css/bootstrap.css" @import "@/assets/css/fonts.css"
	@import "@/assets/css/font-awesome.min.css" @import
	"@/assets/css/owl.carousel.min.css" @import "@/assets/css/style.css";
</style>
